import * as React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { ConfiguredProvidersSection } from "@/components/broker/sections/ConfiguredProvidersSection";
import { ProviderHealthSection } from "@/components/broker/sections/ProviderHealthSection";
import { CapabilitiesSection } from "@/components/broker/sections/CapabilitiesSection";

export function BrokerPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Broker
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Backend-reported broker connectivity only — no login, credentials, or order placement.
        </Typography>
      </Box>
      <Stack spacing={3}>
        <ConfiguredProvidersSection />
        <ProviderHealthSection />
        <CapabilitiesSection />
      </Stack>
    </ResponsiveContainer>
  );
}
